import { render, staticRenderFns } from "./PlayIcon.vue?vue&type=template&id=5be21906&scoped=true&"
import script from "./PlayIcon.vue?vue&type=script&lang=js&"
export * from "./PlayIcon.vue?vue&type=script&lang=js&"
import style0 from "./PlayIcon.vue?vue&type=style&index=0&id=5be21906&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be21906",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/jeffreymb/BibleLing/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5be21906')) {
      api.createRecord('5be21906', component.options)
    } else {
      api.reload('5be21906', component.options)
    }
    module.hot.accept("./PlayIcon.vue?vue&type=template&id=5be21906&scoped=true&", function () {
      api.rerender('5be21906', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PlayIcon.vue"
export default component.exports